import { type IDropdownItem } from 'shared/ui'
import { type IInboxCombine } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeUngroup = 'ungroup'

type IActionUngroup = {
  inbox: IInboxCombine
  item: IDropdownItem
}

export const menuUngroup = (): IDropdownItem => {
  return {
    id: typeUngroup,
    iconL: 'remove',
    label: 'Ungroup',
  }
}

export const actionUngroup = async (
  { inbox, item }: IActionUngroup,
  store: ConversationMenuStore
) => {
  if (item.id === typeUngroup) {
    store.handleDeleteTeamsGroupsById(inbox)
  }
}
